// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"85724836","885":"3cf04a61"}[chunkId] + ".chunk.js";
};